import ClientIntegrationsPage from "containers/ClientIntegrationsPage";
import IntegrationsMonitorPage from "containers/IntegrationsMonitorPage";
import { usePlatformRole } from "features/integrationsBeta/usePlatformRole";

/**
 * /integrations-beta: the internal monitor for every internal platform role,
 * the client-facing list for a client portal user - or an admin previewing
 * one in Client View (CAL-5777). IntegrationsExperienceGate in front of the
 * route lets nobody else through, so `!canView` here means "client". Two
 * components rather than one branching page: each variant keeps its own
 * hooks and queries, and the client one never mounts an internal query.
 */
export default function IntegrationsBetaPage() {
  const { canView } = usePlatformRole();
  return canView ? <IntegrationsMonitorPage /> : <ClientIntegrationsPage />;
}
